import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import appStore from 'client/AppStore';
import sessionStore from 'client/Session/SessionStore';
import {callAction} from 'client/framework';
import DennisLogo from 'assets/images/dennis-nav-logo.svg';
import {Logo, NavItem, Icon} from '@albert-io/atomic';
import UserAvatar from 'generic/UserAvatar/UserAvatar.react';
import classNames from 'classnames';
import {getBaseUserQuery} from 'client/User/UserQueryUtil';

import MarketingNavigation from './MarketingNavigation/MarketingNavigation.react';
import MainNavItems from './MainNavItems/MainNavItems';
import DropdownNavItems from './DropdownNavItems/DropdownNavItems';
import NavWidgets from './NavWidgets/NavWidgets.react';
import globalNavigationActions from './GlobalNavigationActions';
import globalNavigationStore from './GlobalNavigationStore';
import GlobalNavDrawer from './GlobalNavDrawer/GlobalNavDrawer.react';

import stylevars from './global-navigation.scss';
import {GlobalNavBehaviorContext, GlobalNavBehaviorEnum} from './GlobalNavBehavior.context';

const mobileBreakpoint = parseInt(stylevars.mobileBreakpoint, 10);
export default class GlobalNavigation extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    viewportWidth: PropTypes.number,
    requiresEmailVerification: PropTypes.bool
  };

  componentDidMount() {
    const {pathname} = this.props.location;
    callAction(globalNavigationActions.SET_PATHNAME, pathname);
    if (this.windowIsMobile()) {
      callAction(globalNavigationActions.SET_IS_DRAWER_ACTIVE, true);
    }
  }

  componentDidUpdate() {
    if (globalNavigationStore.getIsDrawerActive() === false && this.windowIsMobile()) {
      callAction(globalNavigationActions.SET_IS_DRAWER_ACTIVE, true);
    } else if (globalNavigationStore.getIsDrawerActive() && !this.windowIsMobile()) {
      callAction(globalNavigationActions.SET_IS_DRAWER_ACTIVE, false);
    }
  }

  static contextType = GlobalNavBehaviorContext;

  windowIsMobile() {
    return this.props.viewportWidth < mobileBreakpoint;
  }

  shouldShowMarketingNavigation() {
    const hideHeaderPages = List(['/', '/home']);
    return (
      !this.props.requiresEmailVerification &&
      hideHeaderPages.includes(this.props.location.pathname)
    );
  }

  render() {
    const {navBehavior} = this.context;

    const isUserLoggedIn = sessionStore.hasValidSession();
    if (this.shouldShowMarketingNavigation() || !isUserLoggedIn) {
      return <MarketingNavigation location={this.props.location} />;
    }

    const navWidgetsContent = !this.windowIsMobile() ? <NavWidgets /> : null;

    const mainNavDrawer = globalNavigationStore.getIsDrawerActive() ? (
      <GlobalNavDrawer pathname={this.props.location.pathname} />
    ) : null;

    const user = getBaseUserQuery(sessionStore.getUserId()).getResource();
    const username = user.getUsername();
    const fullName = user.getFullName();
    const userAvatarContent = <UserAvatar username={username} fullName={fullName} />;
    const usernameContent = !this.windowIsMobile() ? (
      <div className='global-nav__username'>{username}</div>
    ) : null;

    return (
      <header
        className={classNames('global-nav', {
          'global-nav-not-sticky': navBehavior === GlobalNavBehaviorEnum.VISIBLE_NOT_STICKY
        })}
      >
        <div className='global-nav__content'>
          {mainNavDrawer}
          <NavItem className='global-nav__title pr-x2' to='/classes'>
            {appStore.isZoneDennis() ? (
              <img
                className='global-nav__dennis-logo'
                src={DennisLogo}
                alt=''
                aria-label='Go to Classes'
              />
            ) : (
              <Logo aria-label='Go to Classes' width='160px' color='white' />
            )}
          </NavItem>
          {!this.windowIsMobile() && <MainNavItems />}
          <nav className='global-nav__account' aria-label='account'>
            <ul className='global-nav__account-list'>
              {navWidgetsContent}
              <DropdownNavItems
                trigger={
                  <NavItem
                    as='div'
                    aria-label='user menu'
                    active={false}
                    disabled={false}
                    tabIndex={0}
                    role='button'
                    data-testid='global-nav__user-menu-dropdown'
                  >
                    {userAvatarContent}
                    {usernameContent}
                    <Icon icon='caret-down' className='ml-x1' />
                  </NavItem>
                }
              />
            </ul>
          </nav>
        </div>
      </header>
    );
  }
}
